import '../base.js';
import '../../../node_modules/@fortawesome/fontawesome-free/js/all.js';

// import './people.scss';
import PEOPLE from './people.data.js';

function createMemberCard(member) {
  let columnEl = document.createElement('div');
  columnEl.classList.add('column');
  let memberEl = document.createElement('article');
  memberEl.classList.add('media', 'svl-people--member-article');
  columnEl.appendChild(memberEl);
  if (member.img) {
    let mediaLeftEl = document.createElement('figure');
    mediaLeftEl.classList.add('media-left', 'image', 'svl-people--member-pic');
    mediaLeftEl.innerHTML = `<img src="${member.img}" >`;
    memberEl.appendChild(mediaLeftEl);
  }
  let mediaContentEl = document.createElement('div');
  mediaContentEl.classList.add('media-content');
  let mediaContent = ``;
  if (member.web) { mediaContent += `<p><span class="svl-people--member-title"><a href="${member.web}">${member.name}</a></span><br>`; }
    else { mediaContent += `<p><span class="svl-people--member-title">${member.name}</span><br>`; } 
  if (member.desc) { mediaContent += `${member.desc}<br>`; }
  if (member.email) { mediaContent += `<span class="mono">${member.email}</span><br>`; }
  mediaContent += '</p>';
  mediaContentEl.innerHTML = mediaContent;
  memberEl.appendChild(mediaContentEl);
  return columnEl;
}

document.addEventListener('DOMContentLoaded', function onLoaded() {
  document.removeEventListener('DOMContentLoaded', onLoaded);
  const sidemenu = document.getElementById('svl-people--sidemenu');
  const content = document.getElementById('svl-people--content');
  for (const group of PEOPLE.groups) {
    let aEl = document.createElement('a');
    const link = group.name.replace(/([\W-])/g, '').toLowerCase();
    aEl.setAttribute('href', '#' + link);
    aEl.innerHTML = group.name;
    let liEl = document.createElement('li');
    liEl.appendChild(aEl);
    sidemenu.appendChild(liEl);

    let titleEl = document.createElement('h4');
    titleEl.innerText = group.name;
    titleEl.classList.add('title', 'is-4');
    titleEl.setAttribute('id', link);
    
    content.appendChild(titleEl);
    
    let ancestorEl = document.createElement('div');
    ancestorEl.classList.add('columns', 'is-multiline', 'is-mobile');
    content.appendChild(ancestorEl);
    for (const member of group.members) {
      ancestorEl.appendChild(createMemberCard(member));
    }

    // Auto-complete to a 3 column grid. This will make it work for any N-column
    // sized grid.
    if ((group.members.length % 3) !== 0) {
      for (let i = 0, len = 3 - (group.members.length % 3); i < len; i++) {
        let extraCol = document.createElement('div');
        extraCol.classList.add('column', 'svl-people--member-article');
        ancestorEl.appendChild(extraCol)
        console.log("Appending", i, len, group.members.length, group.members[0])
      }      
    }
  }
}, false);
